import React from 'react'

import Allergen from 'pmt-modules/user/constants/Allergen'

import CountryChooser from 'pmt-ui/CountryChooser'
import AllergenChooser from 'pmt-modules/user/components/AllergenChooser'

const getComponents = [
  {
    name: 'CountryChooser, single selection',
    definition: (
      <pre>
        {`
          <CountryChooser
            required
            label='Pays de résidence'
            className="u-sizeFullWidth"
            value={'FR'}
            onChange={(country) => {}}
            error={true}
            helperText={'error'}
          />
        `}
      </pre>
    ),
    render: (
      <CountryChooser
        required
        label="Pays de résidence"
        className="u-sizeFullWidth"
        value={'FR'}
        onChange={country => {}}
        error={true}
        helperText={'error'}
      />
    ),
  },
  {
    name: 'AllergenChooser, multiple selection',
    definition: (
      <pre>
        {`
          <AllergenChooser
            value={[
              Allergen.PEANUT,
              Allergen.EGG,
            ]}
            onChange={allergens => {}}
          />
        `}
      </pre>
    ),
    render: <AllergenChooser value={[Allergen.PEANUT, Allergen.EGG]} onChange={allergens => {}} />,
  },
]

export default {
  title: 'List Chooser',
  components: getComponents,
}
